export const scrollToSection = (sectionTitle: string) => {
  const sectionElement = document.getElementById(sectionTitle);
  if (!sectionElement) {
    console.warn(`Section with id ${sectionTitle} not found.`);
    return;
  }
  const scrollTo = sectionElement.offsetTop - 130;
  window.scroll({ top: scrollTo, left: 0, behavior: 'smooth' });
  // Update the URL hash without page reload
  history.pushState(null, '', `#${sectionTitle}`);
};
